export const concatenateStrings = (arr: string[]): string => {
  if (!arr || arr.length === 0) {
    return "";
  }

  const distinctArr: string[] = arr.filter(
    (value, index) => arr.indexOf(value) === index
  );

  if (distinctArr.length === 1) {
    return distinctArr[0];
  }

  return (
    distinctArr.slice(0, -1).join(", ") +
    ", " +
    distinctArr[distinctArr.length - 1]
  );
};
